import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import styles from "../App.module.css";
import { useAuth } from "../context/AuthContext";
import ErrorBubble from "./ErrorBubble";
import facade from "../services/qwof/apiFacade";
import QuagganEmoji from "./QuagganEmoji.jsx";
import iqLogo from "../images/iq_logo.png";

function LoginForm({ onSuccess, onSwitchToRegister, title }) {
  const { isLoggedIn, username, login, logout } = useAuth();
  const [inputUser, setInputUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasAdminAccess, setHasAdminAccess] = useState(false);
  const [isIqMember, setIsIqMember] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Reset before new attempt
    try {
      await login(inputUser, password);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log("Login failed: " + err);
      setErrorMessage("Wrong username or password!");
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      const allowed = facade.hasAnyRole(["ADMIN", "LEADER", "OFFICER"]);
      setHasAdminAccess(allowed);
      const GUILD_IQ_ID = "DA835590-BFBA-4D4C-BF10-014905F32E00";
      if (username) {
        facade
          .isMemberOfGuild(GUILD_IQ_ID, username)
          .then((res) => {
            // Endpoint returns a boolean; treat truthy as member
            setIsIqMember(!!res);
          })
          .catch(() => {
            setIsIqMember(false);
          });
      } else {
        setIsIqMember(false);
      }
    } else {
      setHasAdminAccess(false);
      setIsIqMember(false);
    }
  }, [isLoggedIn, username]);

  return (
    <div className="login-panel">
      {title && <h2 className="register-title">{title}</h2>}
      <div>
        {errorMessage && (
          <>
            <ErrorBubble message={"Wrong username or passsword!"} />
            <QuagganEmoji type="failure" />
          </>
        )}
        {!isLoggedIn ? (
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Username"
              value={inputUser}
              onChange={(e) => setInputUser(e.target.value)}
              className="login-input"
            />
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                style={{ paddingRight: 32 }}
              />
              <span
                onMouseEnter={() => setShowPassword(true)}
                onMouseLeave={() => setShowPassword(false)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "48%",
                  transform: "translateY(-55%)",
                  cursor: "pointer",
                }}
                aria-label="Show password while hovering"
              >
                👁
              </span>
            </div>
            <div className="login-btn-row">
              <button type="submit" className="login-btn">
                Login
              </button>
            </div>
            <p className="login-help-text">
              Don't have an account?{" "}
              {onSwitchToRegister ? (
                <a
                  href="#register"
                  onClick={(e) => {
                    e.preventDefault();
                    onSwitchToRegister();
                  }}
                >
                  Register here!
                </a>
              ) : (
                <Link to="/register">Register here!</Link>
              )}
            </p>
          </form>
        ) : (
          <div>
            <div className="login-logged-row">
              <span>
                <Link to={`/users/${username}`}>
                  <strong>{username}</strong>
                </Link>
                {isIqMember && (
                  <img
                    src={iqLogo}
                    alt="IQ guild logo"
                    style={{
                      height: 24,
                      width: "auto",
                      marginLeft: 8,
                      verticalAlign: "middle",
                    }}
                  />
                )}
              </span>
              <button onClick={logout} className="login-btn">
                Logout
              </button>
            </div>
            {hasAdminAccess && (
              <p className="login-help-text">
                <Link to="/admin/history">Admin Page</Link>
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginForm;
